import { makeElement, insertElement } from './elements.js';
import { frame, pad } from './design.js';

// import './index.css';

export function isCkeditor(element, config) {
    // console.log('enter isCkeditor');
    const div = makeElement('div');
    div.innerHTML = 'I am the div inserted by isCkeditor';
    frame(div);
    pad(div);
    insertElement(div);
}

// console.log('After -export isCkeditor- in isCkeditor.js');

import 'ckeditor5/ckeditor5.css';


// console.log('After -import ckeditor5/ckeditor5.css- in isCkeditor.js');

import {
    ClassicEditor as ClassicEditorBase,
    Essentials,
    Bold,
    Italic,
    Underline,
    Strikethrough,
    Code,
    Subscript,
    Superscript,
    BlockQuote,
    Heading,
    Link,
    List,
    Paragraph,
    FindAndReplace,
    Font,
    HorizontalLine,
    SimpleUploadAdapter,
    ImageUpload,
    Image,
    ImageCaption,
    ImageResize,
    ImageStyle,
    ImageToolbar,
    Indent,
    IndentBlock,
    MediaEmbed,
    PageBreak,
    PasteFromOffice,
    RemoveFormat,
    SourceEditing,
    SpecialCharacters,
    SpecialCharactersEssentials,
    Table,
    TableToolbar,
    TableProperties,
    TableCellProperties,
    CodeBlock,
    WordCount
} from 'ckeditor5';
import MathType from '@wiris/mathtype-ckeditor5/dist/index.js';

import SimpleAudio from './simpleAudio/simpleaudio.js';
import IsPencil from './ispencil/ispencil.js';

// console.log('After -import of plugins- in isCkeditor.js');

import germanTranslation from 'ckeditor5/translations/de.js';
import frenchTranslation from 'ckeditor5/translations/fr.js';
import italianTranslation from 'ckeditor5/translations/it.js';
import spanishTranslation from 'ckeditor5/translations/es.js';


export class ClassicEditor extends ClassicEditorBase {
    static builtinPlugins = [
        Essentials,
        Bold,
        Italic,
        Underline,
        Strikethrough,
        Code,
        Subscript,
        Superscript,
        BlockQuote,
        Heading,
        Link,
        List,
        Paragraph,
        FindAndReplace,
        Font,
        HorizontalLine,
        MathType,
        SimpleAudio,
        SimpleUploadAdapter,
        ImageUpload,
        Image,
        ImageCaption,
        ImageResize,
        ImageStyle,
        ImageToolbar,
        Indent,
        IndentBlock,
        MediaEmbed,
        PageBreak,
        PasteFromOffice,
        RemoveFormat,
        SourceEditing,
        SpecialCharacters,
        SpecialCharactersEssentials,
        Table,
        TableToolbar,
        TableProperties,
        TableCellProperties,
        CodeBlock,
        WordCount,
        IsPencil
    ];
    static defaultConfig = {
        toolbar: {
            items: [
                'undo',
                'redo',
                '|',
                'heading',
                '|',
                'bold',
                'italic',
                'underline',
                'strikethrough',
                'code',
                'subscript',
                'superscript',
                '|',
                'link',
                'bulletedList',
                'numberedList',
                'blockQuote',
                '|',
                'findAndReplace',
                '|',
                'fontSize',
                'fontFamily',
                'fontColor',
                'fontBackgroundColor',
                '|',
                'horizontalLine',
                '|',
                'uploadImage',
                '|',
                'outdent',
                'indent',
                '|',
                'mediaEmbed',
                '|',
                'pageBreak',
                '|',
                'removeFormat',
                '|',
                'sourceEditing',
                '|',
                'specialCharacters',
                '|',
                'insertTable',
                '|',
                'MathType',
                'ChemType',
                '|',
                'simpleAudio',
                '|',
                'isPencil',
                'codeBlock'
            ]
        },
        simpleUpload: {
            uploadUrl: './isUpload.php'
        },
        image: {
            toolbar: [
                'imageStyle:inline',
                'imageStyle:wrapText',
                'imageStyle:breakText',
                '|',
                'toggleImageCaption',
                'imageTextAlternative'
            ]
        },
        isPencil: {
            width: 600,
            height: 400,
            position: 'center',
            hasBorder: true,
            toolbar: [ 'isPencilLeft', 'isPencilCenter', 'isPencilRight' ]
        },
        /* Do not require this here, because it does not work, if there is no php server in the backend
        mathTypeParameters: {
            serviceProviderProperties: {
                URI: 'https://myeclipse/nexteditor4/wiris/integration',
                server: 'php'
            }
        },
        */
        mediaEmbed: {
            'previewsInData': 'true'
        },
        table: {
            'contentToolbar' : [ 'tableColumn', 'tableRow', 'mergeTableCells', 'tableProperties', 'tableCellProperties' ]
        },
        translations: [
            germanTranslation,
            frenchTranslation,
            italianTranslation,
            spanishTranslation
        ],
        language: 'de'
    }
}

// console.log('After -export ClassicEditor- in isCkeditor.js');